import { Edit } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useState } from 'react'
import FormExemplar from './FormExemplar'
import BasicModal from '../../../components/shared/modals/BaseModal'
import { number, func, object } from 'prop-types'
const OpenButton = ({ ...props }) => {
  return (
    <IconButton {...props} sx={{ color: 'rgba(234, 144, 39, 1)' }}>
      <Edit />
    </IconButton>
  )
}

// const [form, setForm] = useState({

// })

const EditExemplar = ({ idExemplar, idObra, buscarExemplares, dados }) => {
  const [status, setStatus] = useState(false)

  return (
    <BasicModal
      title="Editar Exemplar"
      status={status}
      Caller={OpenButton}
      closeEvent={event => {
        setStatus(event)
        // reset()
      }}
      sx={{ minWidth: '60vw', width: { xs: '100vw', md: '60vw' } }}
    >
      <FormExemplar
        idExemplar={parseInt(idExemplar)}
        idObra={parseInt(idObra)}
        onSubmit={() => buscarExemplares()}
        submitMethod="put"
        dados={dados}
      />
    </BasicModal>
  )
}

EditExemplar.propTypes = {
  idObra: number,
  buscarExemplares: func,
  dados: object,
  idExemplar: number
}

export default EditExemplar
